export default __webpack_public_path__ + "static/media/Ellipse.642ed691.svg";